<script lang="ts">
    import Button from './Button.svelte';
    import Freitext from './Freitext.svelte';

    import { nachrichten, playGong } from './store';

    let text;
    let textDisplay;

    function addText() {
        nachrichten.set([...$nachrichten, { text, textDisplay }]);
        text = '';
        textDisplay = '';
    }
    function changeGong() {
        console.log('Change');
        playGong.set(!$playGong);
        console.log($playGong);
    }
    //@ts-ignore
</script>

<div
    class="flex items-center justify-between space-x-4 mb-5 px-4 max-w-screen-xl mx-auto"
>
    <div class="flex items-center justify-center space-x-4">
        <span class="font-black text-red-600 text-8xl leading-none">+</span>
        <h1 class="text-5xl text-center font-bold leading-none mt-3">
            DRK Soundboard
        </h1>
    </div>
    <div class="flex items-center justify-center space-x-2">
        <input
            id="gong"
            checked={$playGong}
            on:click={changeGong}
            type="checkbox"
            class="w-5 h-5"
        />
        <label for="gong" class="text-lg">Gong an</label>
    </div>
</div>
<div class=" max-w-screen-xl mx-auto px-4">
    <div
        class="grid xl:grid-cols-6 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4 justify-items-center w-full mb-5"
    >
        {#each $nachrichten || [] as nachricht, i}
            <Button
                index={i}
                text={nachricht.text}
                textDisplay={nachricht.textDisplay || nachricht.text}
            />
        {/each}
    </div>

    <Freitext />
    <hr class="my-10" />
    <div class="flex space-x-4">
        <input
            type="text"
            placeholder="Text der gesprochen wird."
            class="flex-1 border border-gray-300 rounded text-xl px-2"
            bind:value={text}
        />
        <input
            type="text"
            placeholder="Text der angezeigt wird (optional)"
            class="flex-1 border border-gray-300 rounded text-xl px-2"
            bind:value={textDisplay}
        />
        <button
            on:click={addText}
            class="px-10 bg-red-600 rounded-lg drop-shadow text-white p-2 text-2xl font-medium"
        >
            Hinzufügen</button
        >
    </div>
</div>

<style global>
    @tailwind base;
    @tailwind components;
    @tailwind utilities;
</style>
